/* Copyright IBM Corp. 2017 */
import { Observable, ReplaySubject } from 'rxjs';

import { RenderingContext } from './../../api';

const _ReplaySubject = ReplaySubject;

// allows to attach for modifications of the components
const pageSubject = new _ReplaySubject<RenderingContext>(1);

function _getActivePage(): Observable<RenderingContext> {
    return pageSubject;
}

function _setActivePage(aRenderingContext: RenderingContext): void {
    pageSubject.next(aRenderingContext);
}

function _disposeActivePage() {
    pageSubject.complete();
}

export {
    _getActivePage as pageGetActivePage,
    _setActivePage as pageSetActivePage,
    _disposeActivePage as pageDisposeActivePage
};

